import { render, staticRenderFns } from "./ReactionEmoji.vue?vue&type=template&id=1def9720&"
import script from "./ReactionEmoji.vue?vue&type=script&lang=js&"
export * from "./ReactionEmoji.vue?vue&type=script&lang=js&"
import style0 from "./ReactionEmoji.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports